export default {"src":"/_next/static/media/choix.d894b64d.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};